import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { AssetsCard } from '../../components/AssetsCard/AssetsCard';
import { Table } from '../../components/Table/Table';
import { Stats } from '../../components/Stats/Stats';
import { DEFAULT_TITLE_MAP } from '../../DetailNetWorth.meta';
import { SummarySectionDTO } from '../../../../api/useBalanceSheetQuery';

interface Props {
  data: SummarySectionDTO;
}

export const Summary = ({ data }: Props) => {
  const { outOfEstateAssets, inEstateAssets } = data;

  return (
    <>
      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        css={({ theme }) => ({ gap: theme.space['24'] })}
        style={{ pageBreakInside: 'avoid' }}
      >
        {!outOfEstateAssets && (
          <Box>
            <Text fontSize="h3" fontWeight={600}>
              Net Worth Summary
            </Text>

            <Text color="neutral.600">
              Your net worth summary shows your total assets minus liabilities, giving you a
              complete picture of your financial position.
            </Text>
          </Box>
        )}

        <Stats data={data} showDescription={!!outOfEstateAssets} />

        <AssetsCard title={DEFAULT_TITLE_MAP.InEstate} {...inEstateAssets} />

        <Table variant="InEstate" tableData={inEstateAssets.table} />
      </Box>

      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        css={({ theme }) => ({ gap: theme.space['24'] })}
        style={{ pageBreakInside: 'avoid' }}
      >
        {outOfEstateAssets && (
          <>
            <AssetsCard title={DEFAULT_TITLE_MAP.OutsideEstate} {...outOfEstateAssets} />

            <Table variant="OutsideEstate" tableData={outOfEstateAssets.table} />
          </>
        )}
      </Box>
    </>
  );
};
